import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/wishlist'

import { withCms, withLayout } from '../cms'
import { withCart } from '../components/hocs/with-cart'

import '@grandvisionhq/fun-wishlist/styles.css'

const WishlistPage: NextPage = () => <Page />

export default compose(withCms(), withLayout(), withCart())(WishlistPage)
